const BanzaButtonPresets = {
  BanzaButton: {
    class: "banza-btn rounded-lg",
    attrs: {
      variant: "text",
      color: "primary"
    },
    presets: {
      icon: {
        attrs: {
          variant: "outlined"
        }
      },
      ["icon-mini"]: {
        class: "px-0 rounded-lg",
        attrs: {
          "variant": "text",
          "size": "small",
          "min-width": 24
        }
      },
      orange: {
        class: "orange",
        attrs: {
          color: "black"
        }
      },
      purple: {
        class: "purple",
        attrs: {}
      },
      flat: {
        class: "text-white",
        attrs: {
          variant: "flat",
          color: "primary"
        }
      },
      back: {
        class: "px-0 rounded-lg",
        isClassOverride: true,
        attrs: {
          "variant": "text",
          "color": "primary",
          "min-width": 24
        },
        slots: {
          icon: {
            attrs: {
              icon: "mdi-arrow-left",
              size: 24
            }
          }
        }
      },
      closeMini: {
        class: "px-0 rounded-lg",
        isClassOverride: true,
        attrs: {
          variant: "text",
          color: "primary",
          size: 40
        },
        slots: {
          icon: {
            attrs: {
              icon: "mdi-close",
              size: 24
            }
          }
        }
      },
      closeIcon: {
        preset: "BanzaButton.icon",
        attrs: {
          size: 24
        },
        slots: {
          icon: {
            attrs: {
              icon: "mdi-close",
              size: 18
            }
          }
        }
      },
      moduleEdit: {
        preset: "BanzaButton.icon",
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:edit-duotone"
            }
          }
        }
      },
      saveMini: {
        preset: "BanzaButton.icon",
        slots: {
          icon: {
            attrs: {
              icon: "fluent:save-20-filled"
            }
          }
        }
      },
      moduleReload: {
        preset: "BanzaButton.icon",
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:refresh-2-light"
            }
          }
        }
      },
      cancel: {
        attrs: {
          textLcz: "base.buttons.cancel"
        },
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:refund-back-light"
            }
          }
        }
      },
      save: {
        class: "text-white",
        attrs: {
          variant: "flat",
          color: "primary",
          textLcz: "base.buttons.save"
        },
        slots: {
          icon: {
            attrs: {
              icon: "fluent:save-20-filled"
            }
          }
        }
      },
      delete: {
        preset: "BanzaButton.orange",
        attrs: {
          textLcz: "base.buttons.delete"
        },
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:trash-duotone",
              color: "#474554"
            }
          }
        }
      },
      close: {
        attrs: {
          variant: "text",
          color: "primary",
          textLcz: "base.buttons.close"
        }
      },
      filterLoading: {
        preset: "BanzaButton.icon",
        class: " spin",
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:compass-duotone-line",
              color: "#f1f1f1"
            }
          }
        },
        attrs: {
          variant: "flat"
        }
      },
      filterAdd: {
        preset: "BanzaButton.icon",
        class: "",
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:filter-alt-duotone-line",
              color: "#f1f1f1"
            }
          }
        },
        attrs: {
          variant: "flat"
        }
      },
      filterSelected: {
        preset: "BanzaButton.icon",
        class: "orange",
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:setting-line-duotone-line",
              color: "#474554"
            }
          }
        },
        attrs: {
          color: "#ffefd1",
          variant: "flat"
        }
      },
      hiddenColumns: {
        attrs: {
          textLcz: "base.buttons.hidden_columns"
        },
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:eye-duotone"
            }
          }
        }
      },
      hiddenColumns2: {
        preset: "BanzaButton.icon",
        attrs: {},
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:eye-duotone"
            }
          }
        }
      },
      exportTo: {
        attrs: {
          textLcz: "base.buttons.export_to"
        },
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:download-duotone",
              right: true
            }
          }
        }
      },
      add: {
        class: "",
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:add-square-duotone"
            }
          }
        },
        attrs: {
          variant: "text",
          textLcz: "base.buttons.add"
        }
      },
      publish: {
        class: "text-white",
        attrs: {
          variant: "flat",
          color: "primary",
          textLcz: "base.buttons.publish"
        },
        slots: {
          icon: {
            attrs: {
              right: true,
              icon: "lets-icons:send-fill"
            }
          }
        }
      },
      generateCode: {
        preset: "BanzaButton.orange",
        attrs: {
          textLcz: "base.buttons.generate_code"
        },
        slots: {
          icon: {
            attrs: {
              class: "mr-1",
              icon: "lets-icons:refresh-2-light"
            }
          }
        }
      },
      contentEdit: {
        attrs: {
          textLcz: "components.admin.notification_template_edit.open_editor"
        },
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:edit-duotone"
            }
          }
        }
      },
      copy: {
        attrs: {
          textLcz: "base.buttons.copy"
        },
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:copy-light"
            }
          }
        }
      },
      screenshot: {
        attrs: {
          textLcz: "base.buttons.screenshot"
        },
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:camera-duotone-line",
              right: true
            }
          }
        }
      },
      view: {
        attrs: {
          textLcz: "base.buttons.view"
        },
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:eye-duotone"
            }
          }
        }
      },
      showHistory: {
        attrs: {
          textLcz: "base.buttons.show_changes_history"
        },
        slots: {
          icon: {
            attrs: {
              icon: "mdi-history"
            }
          }
        }
      },
      goBack: {
        preset: "BanzaButton.orange",
        attrs: {
          textLcz: "base.buttons.goBack"
        },
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:arrow-left-light"
            }
          }
        }
      },
      favoriteAdd: {
        attrs: {
          textLcz: "base.buttons.favorites"
        },
        slots: {
          icon: {
            attrs: {
              icon: "solar:star-linear"
            }
          }
        }
      },
      favoriteSelected: {
        class: "orange",
        attrs: {
          color: "black",
          textLcz: "base.buttons.favorites"
        },
        slots: {
          icon: {
            attrs: {
              icon: "solar:star-bold",
              color: "#474554"
            }
          }
        }
      },
      upload: {
        attrs: {
          textLcz: "base.buttons.load"
        },
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:upload-duotone",
              color: "primary"
            }
          }
        }
      }
    }
  }
};
export {
  BanzaButtonPresets as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFuemFCdXR0b25QcmVzZXRzLmpzIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29uc3RhbnRzL2NvbXBvbmVudHMvQmFuemFCdXR0b25QcmVzZXRzLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHtcblx0QmFuemFCdXR0b246IHtcblx0XHRjbGFzczogXCJiYW56YS1idG4gcm91bmRlZC1sZ1wiLFxuXHRcdGF0dHJzOiB7XG5cdFx0XHR2YXJpYW50OiBcInRleHRcIixcblx0XHRcdGNvbG9yOiBcInByaW1hcnlcIixcblx0XHR9LFxuXHRcdHByZXNldHM6IHtcblx0XHRcdGljb246IHtcblx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHR2YXJpYW50OiBcIm91dGxpbmVkXCIsXG5cdFx0XHRcdH0sXG5cdFx0XHR9LFxuXHRcdFx0W1wiaWNvbi1taW5pXCJdOiB7XG5cdFx0XHRcdGNsYXNzOiBcInB4LTAgcm91bmRlZC1sZ1wiLFxuXHRcdFx0XHRhdHRyczoge1xuXHRcdFx0XHRcdFwidmFyaWFudFwiOiBcInRleHRcIixcblx0XHRcdFx0XHRcInNpemVcIjogXCJzbWFsbFwiLFxuXHRcdFx0XHRcdFwibWluLXdpZHRoXCI6IDI0LFxuXHRcdFx0XHR9LFxuXHRcdFx0fSxcblx0XHRcdG9yYW5nZToge1xuXHRcdFx0XHRjbGFzczogXCJvcmFuZ2VcIixcblx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHRjb2xvcjogXCJibGFja1wiLFxuXHRcdFx0XHR9LFxuXHRcdFx0fSxcblx0XHRcdHB1cnBsZToge1xuXHRcdFx0XHRjbGFzczogXCJwdXJwbGVcIixcblx0XHRcdFx0YXR0cnM6IHt9LFxuXHRcdFx0fSxcblx0XHRcdGZsYXQ6IHtcblx0XHRcdFx0Y2xhc3M6IFwidGV4dC13aGl0ZVwiLFxuXHRcdFx0XHRhdHRyczoge1xuXHRcdFx0XHRcdHZhcmlhbnQ6IFwiZmxhdFwiLFxuXHRcdFx0XHRcdGNvbG9yOiBcInByaW1hcnlcIixcblx0XHRcdFx0fSxcblx0XHRcdH0sXG5cdFx0XHRiYWNrOiB7XG5cdFx0XHRcdGNsYXNzOiBcInB4LTAgcm91bmRlZC1sZ1wiLFxuXHRcdFx0XHRpc0NsYXNzT3ZlcnJpZGU6IHRydWUsXG5cdFx0XHRcdGF0dHJzOiB7XG5cdFx0XHRcdFx0XCJ2YXJpYW50XCI6IFwidGV4dFwiLFxuXHRcdFx0XHRcdFwiY29sb3JcIjogXCJwcmltYXJ5XCIsXG5cdFx0XHRcdFx0XCJtaW4td2lkdGhcIjogMjQsXG5cdFx0XHRcdH0sXG5cdFx0XHRcdHNsb3RzOiB7XG5cdFx0XHRcdFx0aWNvbjoge1xuXHRcdFx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHRcdFx0aWNvbjogXCJtZGktYXJyb3ctbGVmdFwiLFxuXHRcdFx0XHRcdFx0XHRzaXplOiAyNCxcblx0XHRcdFx0XHRcdH0sXG5cdFx0XHRcdFx0fSxcblx0XHRcdFx0fSxcblx0XHRcdH0sXG5cdFx0XHRjbG9zZU1pbmk6IHtcblx0XHRcdFx0Y2xhc3M6IFwicHgtMCByb3VuZGVkLWxnXCIsXG5cdFx0XHRcdGlzQ2xhc3NPdmVycmlkZTogdHJ1ZSxcblx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHR2YXJpYW50OiBcInRleHRcIixcblx0XHRcdFx0XHRjb2xvcjogXCJwcmltYXJ5XCIsXG5cdFx0XHRcdFx0c2l6ZTogNDAsXG5cdFx0XHRcdH0sXG5cdFx0XHRcdHNsb3RzOiB7XG5cdFx0XHRcdFx0aWNvbjoge1xuXHRcdFx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHRcdFx0aWNvbjogXCJtZGktY2xvc2VcIixcblx0XHRcdFx0XHRcdFx0c2l6ZTogMjQsXG5cdFx0XHRcdFx0XHR9LFxuXHRcdFx0XHRcdH0sXG5cdFx0XHRcdH0sXG5cdFx0XHR9LFxuXHRcdFx0Y2xvc2VJY29uOiB7XG5cdFx0XHRcdHByZXNldDogXCJCYW56YUJ1dHRvbi5pY29uXCIsXG5cdFx0XHRcdGF0dHJzOiB7XG5cdFx0XHRcdFx0c2l6ZTogMjQsXG5cdFx0XHRcdH0sXG5cdFx0XHRcdHNsb3RzOiB7XG5cdFx0XHRcdFx0aWNvbjoge1xuXHRcdFx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHRcdFx0aWNvbjogXCJtZGktY2xvc2VcIixcblx0XHRcdFx0XHRcdFx0c2l6ZTogMTgsXG5cdFx0XHRcdFx0XHR9LFxuXHRcdFx0XHRcdH0sXG5cdFx0XHRcdH0sXG5cdFx0XHR9LFxuXHRcdFx0bW9kdWxlRWRpdDoge1xuXHRcdFx0XHRwcmVzZXQ6IFwiQmFuemFCdXR0b24uaWNvblwiLFxuXHRcdFx0XHRzbG90czoge1xuXHRcdFx0XHRcdGljb246IHtcblx0XHRcdFx0XHRcdGF0dHJzOiB7XG5cdFx0XHRcdFx0XHRcdGljb246IFwibGV0cy1pY29uczplZGl0LWR1b3RvbmVcIixcblx0XHRcdFx0XHRcdH0sXG5cdFx0XHRcdFx0fSxcblx0XHRcdFx0fSxcblx0XHRcdH0sXG5cdFx0XHRzYXZlTWluaToge1xuXHRcdFx0XHRwcmVzZXQ6IFwiQmFuemFCdXR0b24uaWNvblwiLFxuXHRcdFx0XHRzbG90czoge1xuXHRcdFx0XHRcdGljb246IHtcblx0XHRcdFx0XHRcdGF0dHJzOiB7XG5cdFx0XHRcdFx0XHRcdGljb246IFwiZmx1ZW50OnNhdmUtMjAtZmlsbGVkXCIsXG5cdFx0XHRcdFx0XHR9LFxuXHRcdFx0XHRcdH0sXG5cdFx0XHRcdH0sXG5cdFx0XHR9LFxuXHRcdFx0bW9kdWxlUmVsb2FkOiB7XG5cdFx0XHRcdHByZXNldDogXCJCYW56YUJ1dHRvbi5pY29uXCIsXG5cdFx0XHRcdHNsb3RzOiB7XG5cdFx0XHRcdFx0aWNvbjoge1xuXHRcdFx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHRcdFx0aWNvbjogXCJsZXRzLWljb25zOnJlZnJlc2gtMi1saWdodFwiLFxuXHRcdFx0XHRcdFx0fSxcblx0XHRcdFx0XHR9LFxuXHRcdFx0XHR9LFxuXHRcdFx0fSxcblx0XHRcdGNhbmNlbDoge1xuXHRcdFx0XHRhdHRyczoge1xuXHRcdFx0XHRcdHRleHRMY3o6IFwiYmFzZS5idXR0b25zLmNhbmNlbFwiLFxuXHRcdFx0XHR9LFxuXHRcdFx0XHRzbG90czoge1xuXHRcdFx0XHRcdGljb246IHtcblx0XHRcdFx0XHRcdGF0dHJzOiB7XG5cdFx0XHRcdFx0XHRcdGljb246IFwibGV0cy1pY29uczpyZWZ1bmQtYmFjay1saWdodFwiLFxuXHRcdFx0XHRcdFx0fSxcblx0XHRcdFx0XHR9LFxuXHRcdFx0XHR9LFxuXHRcdFx0fSxcblx0XHRcdHNhdmU6IHtcblx0XHRcdFx0Y2xhc3M6IFwidGV4dC13aGl0ZVwiLFxuXHRcdFx0XHRhdHRyczoge1xuXHRcdFx0XHRcdHZhcmlhbnQ6IFwiZmxhdFwiLFxuXHRcdFx0XHRcdGNvbG9yOiBcInByaW1hcnlcIixcblx0XHRcdFx0XHR0ZXh0TGN6OiBcImJhc2UuYnV0dG9ucy5zYXZlXCIsXG5cdFx0XHRcdH0sXG5cdFx0XHRcdHNsb3RzOiB7XG5cdFx0XHRcdFx0aWNvbjoge1xuXHRcdFx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHRcdFx0aWNvbjogXCJmbHVlbnQ6c2F2ZS0yMC1maWxsZWRcIixcblx0XHRcdFx0XHRcdH0sXG5cdFx0XHRcdFx0fSxcblx0XHRcdFx0fSxcblx0XHRcdH0sXG5cdFx0XHRkZWxldGU6IHtcblx0XHRcdFx0cHJlc2V0OiBcIkJhbnphQnV0dG9uLm9yYW5nZVwiLFxuXHRcdFx0XHRhdHRyczoge1xuXHRcdFx0XHRcdHRleHRMY3o6IFwiYmFzZS5idXR0b25zLmRlbGV0ZVwiLFxuXHRcdFx0XHR9LFxuXHRcdFx0XHRzbG90czoge1xuXHRcdFx0XHRcdGljb246IHtcblx0XHRcdFx0XHRcdGF0dHJzOiB7XG5cdFx0XHRcdFx0XHRcdGljb246IFwibGV0cy1pY29uczp0cmFzaC1kdW90b25lXCIsXG5cdFx0XHRcdFx0XHRcdGNvbG9yOiBcIiM0NzQ1NTRcIixcblx0XHRcdFx0XHRcdH0sXG5cdFx0XHRcdFx0fSxcblx0XHRcdFx0fSxcblx0XHRcdH0sXG5cdFx0XHRjbG9zZToge1xuXHRcdFx0XHRhdHRyczoge1xuXHRcdFx0XHRcdHZhcmlhbnQ6IFwidGV4dFwiLFxuXHRcdFx0XHRcdGNvbG9yOiBcInByaW1hcnlcIixcblx0XHRcdFx0XHR0ZXh0TGN6OiBcImJhc2UuYnV0dG9ucy5jbG9zZVwiLFxuXHRcdFx0XHR9LFxuXHRcdFx0fSxcblx0XHRcdGZpbHRlckxvYWRpbmc6IHtcblx0XHRcdFx0cHJlc2V0OiBcIkJhbnphQnV0dG9uLmljb25cIixcblx0XHRcdFx0Y2xhc3M6IFwiIHNwaW5cIixcblx0XHRcdFx0c2xvdHM6IHtcblx0XHRcdFx0XHRpY29uOiB7XG5cdFx0XHRcdFx0XHRhdHRyczoge1xuXHRcdFx0XHRcdFx0XHRpY29uOiBcImxldHMtaWNvbnM6Y29tcGFzcy1kdW90b25lLWxpbmVcIixcblx0XHRcdFx0XHRcdFx0Y29sb3I6IFwiI2YxZjFmMVwiLFxuXHRcdFx0XHRcdFx0fSxcblx0XHRcdFx0XHR9LFxuXHRcdFx0XHR9LFxuXHRcdFx0XHRhdHRyczoge1xuXHRcdFx0XHRcdHZhcmlhbnQ6IFwiZmxhdFwiLFxuXHRcdFx0XHR9LFxuXHRcdFx0fSxcblx0XHRcdGZpbHRlckFkZDoge1xuXHRcdFx0XHRwcmVzZXQ6IFwiQmFuemFCdXR0b24uaWNvblwiLFxuXHRcdFx0XHRjbGFzczogXCJcIixcblx0XHRcdFx0c2xvdHM6IHtcblx0XHRcdFx0XHRpY29uOiB7XG5cdFx0XHRcdFx0XHRhdHRyczoge1xuXHRcdFx0XHRcdFx0XHRpY29uOiBcImxldHMtaWNvbnM6ZmlsdGVyLWFsdC1kdW90b25lLWxpbmVcIixcblx0XHRcdFx0XHRcdFx0Y29sb3I6IFwiI2YxZjFmMVwiLFxuXHRcdFx0XHRcdFx0fSxcblx0XHRcdFx0XHR9LFxuXHRcdFx0XHR9LFxuXHRcdFx0XHRhdHRyczoge1xuXHRcdFx0XHRcdHZhcmlhbnQ6IFwiZmxhdFwiLFxuXHRcdFx0XHR9LFxuXHRcdFx0fSxcblx0XHRcdGZpbHRlclNlbGVjdGVkOiB7XG5cdFx0XHRcdHByZXNldDogXCJCYW56YUJ1dHRvbi5pY29uXCIsXG5cdFx0XHRcdGNsYXNzOiBcIm9yYW5nZVwiLFxuXHRcdFx0XHRzbG90czoge1xuXHRcdFx0XHRcdGljb246IHtcblx0XHRcdFx0XHRcdGF0dHJzOiB7XG5cdFx0XHRcdFx0XHRcdGljb246IFwibGV0cy1pY29uczpzZXR0aW5nLWxpbmUtZHVvdG9uZS1saW5lXCIsXG5cdFx0XHRcdFx0XHRcdGNvbG9yOiBcIiM0NzQ1NTRcIixcblx0XHRcdFx0XHRcdH0sXG5cdFx0XHRcdFx0fSxcblx0XHRcdFx0fSxcblx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHRjb2xvcjogXCIjZmZlZmQxXCIsXG5cdFx0XHRcdFx0dmFyaWFudDogXCJmbGF0XCIsXG5cdFx0XHRcdH0sXG5cdFx0XHR9LFxuXHRcdFx0aGlkZGVuQ29sdW1uczoge1xuXHRcdFx0XHRhdHRyczoge1xuXHRcdFx0XHRcdHRleHRMY3o6IFwiYmFzZS5idXR0b25zLmhpZGRlbl9jb2x1bW5zXCIsXG5cdFx0XHRcdH0sXG5cdFx0XHRcdHNsb3RzOiB7XG5cdFx0XHRcdFx0aWNvbjoge1xuXHRcdFx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHRcdFx0aWNvbjogXCJsZXRzLWljb25zOmV5ZS1kdW90b25lXCIsXG5cdFx0XHRcdFx0XHR9LFxuXHRcdFx0XHRcdH0sXG5cdFx0XHRcdH0sXG5cdFx0XHR9LFxuXHRcdFx0aGlkZGVuQ29sdW1uczI6IHtcblx0XHRcdFx0cHJlc2V0OiBcIkJhbnphQnV0dG9uLmljb25cIixcblx0XHRcdFx0YXR0cnM6IHt9LFxuXHRcdFx0XHRzbG90czoge1xuXHRcdFx0XHRcdGljb246IHtcblx0XHRcdFx0XHRcdGF0dHJzOiB7XG5cdFx0XHRcdFx0XHRcdGljb246IFwibGV0cy1pY29uczpleWUtZHVvdG9uZVwiLFxuXHRcdFx0XHRcdFx0fSxcblx0XHRcdFx0XHR9LFxuXHRcdFx0XHR9LFxuXHRcdFx0fSxcblx0XHRcdGV4cG9ydFRvOiB7XG5cdFx0XHRcdGF0dHJzOiB7XG5cdFx0XHRcdFx0dGV4dExjejogXCJiYXNlLmJ1dHRvbnMuZXhwb3J0X3RvXCIsXG5cdFx0XHRcdH0sXG5cdFx0XHRcdHNsb3RzOiB7XG5cdFx0XHRcdFx0aWNvbjoge1xuXHRcdFx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHRcdFx0aWNvbjogXCJsZXRzLWljb25zOmRvd25sb2FkLWR1b3RvbmVcIixcblx0XHRcdFx0XHRcdFx0cmlnaHQ6IHRydWUsXG5cdFx0XHRcdFx0XHR9LFxuXHRcdFx0XHRcdH0sXG5cdFx0XHRcdH0sXG5cdFx0XHR9LFxuXHRcdFx0YWRkOiB7XG5cdFx0XHRcdGNsYXNzOiBcIlwiLFxuXHRcdFx0XHRzbG90czoge1xuXHRcdFx0XHRcdGljb246IHtcblx0XHRcdFx0XHRcdGF0dHJzOiB7XG5cdFx0XHRcdFx0XHRcdGljb246IFwibGV0cy1pY29uczphZGQtc3F1YXJlLWR1b3RvbmVcIixcblx0XHRcdFx0XHRcdH0sXG5cdFx0XHRcdFx0fSxcblx0XHRcdFx0fSxcblx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHR2YXJpYW50OiBcInRleHRcIixcblx0XHRcdFx0XHR0ZXh0TGN6OiBcImJhc2UuYnV0dG9ucy5hZGRcIixcblx0XHRcdFx0fSxcblx0XHRcdH0sXG5cdFx0XHRwdWJsaXNoOiB7XG5cdFx0XHRcdGNsYXNzOiBcInRleHQtd2hpdGVcIixcblx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHR2YXJpYW50OiBcImZsYXRcIixcblx0XHRcdFx0XHRjb2xvcjogXCJwcmltYXJ5XCIsXG5cdFx0XHRcdFx0dGV4dExjejogXCJiYXNlLmJ1dHRvbnMucHVibGlzaFwiLFxuXHRcdFx0XHR9LFxuXHRcdFx0XHRzbG90czoge1xuXHRcdFx0XHRcdGljb246IHtcblx0XHRcdFx0XHRcdGF0dHJzOiB7XG5cdFx0XHRcdFx0XHRcdHJpZ2h0OiB0cnVlLFxuXHRcdFx0XHRcdFx0XHRpY29uOiBcImxldHMtaWNvbnM6c2VuZC1maWxsXCIsXG5cdFx0XHRcdFx0XHR9LFxuXHRcdFx0XHRcdH0sXG5cdFx0XHRcdH0sXG5cdFx0XHR9LFxuXHRcdFx0Z2VuZXJhdGVDb2RlOiB7XG5cdFx0XHRcdHByZXNldDogXCJCYW56YUJ1dHRvbi5vcmFuZ2VcIixcblx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHR0ZXh0TGN6OiBcImJhc2UuYnV0dG9ucy5nZW5lcmF0ZV9jb2RlXCIsXG5cdFx0XHRcdH0sXG5cdFx0XHRcdHNsb3RzOiB7XG5cdFx0XHRcdFx0aWNvbjoge1xuXHRcdFx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHRcdFx0Y2xhc3M6IFwibXItMVwiLFxuXHRcdFx0XHRcdFx0XHRpY29uOiBcImxldHMtaWNvbnM6cmVmcmVzaC0yLWxpZ2h0XCIsXG5cdFx0XHRcdFx0XHR9LFxuXHRcdFx0XHRcdH0sXG5cdFx0XHRcdH0sXG5cdFx0XHR9LFxuXHRcdFx0Y29udGVudEVkaXQ6IHtcblx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHR0ZXh0TGN6OlxuXHRcdFx0XHRcdFx0XCJjb21wb25lbnRzLmFkbWluLm5vdGlmaWNhdGlvbl90ZW1wbGF0ZV9lZGl0Lm9wZW5fZWRpdG9yXCIsXG5cdFx0XHRcdH0sXG5cdFx0XHRcdHNsb3RzOiB7XG5cdFx0XHRcdFx0aWNvbjoge1xuXHRcdFx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHRcdFx0aWNvbjogXCJsZXRzLWljb25zOmVkaXQtZHVvdG9uZVwiLFxuXHRcdFx0XHRcdFx0fSxcblx0XHRcdFx0XHR9LFxuXHRcdFx0XHR9LFxuXHRcdFx0fSxcblx0XHRcdGNvcHk6IHtcblx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHR0ZXh0TGN6OiBcImJhc2UuYnV0dG9ucy5jb3B5XCIsXG5cdFx0XHRcdH0sXG5cdFx0XHRcdHNsb3RzOiB7XG5cdFx0XHRcdFx0aWNvbjoge1xuXHRcdFx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHRcdFx0aWNvbjogXCJsZXRzLWljb25zOmNvcHktbGlnaHRcIixcblx0XHRcdFx0XHRcdH0sXG5cdFx0XHRcdFx0fSxcblx0XHRcdFx0fSxcblx0XHRcdH0sXG5cdFx0XHRzY3JlZW5zaG90OiB7XG5cdFx0XHRcdGF0dHJzOiB7XG5cdFx0XHRcdFx0dGV4dExjejogXCJiYXNlLmJ1dHRvbnMuc2NyZWVuc2hvdFwiLFxuXHRcdFx0XHR9LFxuXHRcdFx0XHRzbG90czoge1xuXHRcdFx0XHRcdGljb246IHtcblx0XHRcdFx0XHRcdGF0dHJzOiB7XG5cdFx0XHRcdFx0XHRcdGljb246IFwibGV0cy1pY29uczpjYW1lcmEtZHVvdG9uZS1saW5lXCIsXG5cdFx0XHRcdFx0XHRcdHJpZ2h0OiB0cnVlLFxuXHRcdFx0XHRcdFx0fSxcblx0XHRcdFx0XHR9LFxuXHRcdFx0XHR9LFxuXHRcdFx0fSxcblx0XHRcdHZpZXc6IHtcblx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHR0ZXh0TGN6OiBcImJhc2UuYnV0dG9ucy52aWV3XCIsXG5cdFx0XHRcdH0sXG5cdFx0XHRcdHNsb3RzOiB7XG5cdFx0XHRcdFx0aWNvbjoge1xuXHRcdFx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHRcdFx0aWNvbjogXCJsZXRzLWljb25zOmV5ZS1kdW90b25lXCIsXG5cdFx0XHRcdFx0XHR9LFxuXHRcdFx0XHRcdH0sXG5cdFx0XHRcdH0sXG5cdFx0XHR9LFxuXHRcdFx0c2hvd0hpc3Rvcnk6IHtcblx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHR0ZXh0TGN6OiBcImJhc2UuYnV0dG9ucy5zaG93X2NoYW5nZXNfaGlzdG9yeVwiLFxuXHRcdFx0XHR9LFxuXHRcdFx0XHRzbG90czoge1xuXHRcdFx0XHRcdGljb246IHtcblx0XHRcdFx0XHRcdGF0dHJzOiB7XG5cdFx0XHRcdFx0XHRcdGljb246IFwibWRpLWhpc3RvcnlcIixcblx0XHRcdFx0XHRcdH0sXG5cdFx0XHRcdFx0fSxcblx0XHRcdFx0fSxcblx0XHRcdH0sXG5cdFx0XHRnb0JhY2s6IHtcblx0XHRcdFx0cHJlc2V0OiBcIkJhbnphQnV0dG9uLm9yYW5nZVwiLFxuXHRcdFx0XHRhdHRyczoge1xuXHRcdFx0XHRcdHRleHRMY3o6IFwiYmFzZS5idXR0b25zLmdvQmFja1wiLFxuXHRcdFx0XHR9LFxuXHRcdFx0XHRzbG90czoge1xuXHRcdFx0XHRcdGljb246IHtcblx0XHRcdFx0XHRcdGF0dHJzOiB7XG5cdFx0XHRcdFx0XHRcdGljb246IFwibGV0cy1pY29uczphcnJvdy1sZWZ0LWxpZ2h0XCIsXG5cdFx0XHRcdFx0XHR9LFxuXHRcdFx0XHRcdH0sXG5cdFx0XHRcdH0sXG5cdFx0XHR9LFxuXHRcdFx0ZmF2b3JpdGVBZGQ6IHtcblx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHR0ZXh0TGN6OiBcImJhc2UuYnV0dG9ucy5mYXZvcml0ZXNcIixcblx0XHRcdFx0fSxcblx0XHRcdFx0c2xvdHM6IHtcblx0XHRcdFx0XHRpY29uOiB7XG5cdFx0XHRcdFx0XHRhdHRyczoge1xuXHRcdFx0XHRcdFx0XHRpY29uOiBcInNvbGFyOnN0YXItbGluZWFyXCIsXG5cdFx0XHRcdFx0XHR9LFxuXHRcdFx0XHRcdH0sXG5cdFx0XHRcdH0sXG5cdFx0XHR9LFxuXHRcdFx0ZmF2b3JpdGVTZWxlY3RlZDoge1xuXHRcdFx0XHRjbGFzczogXCJvcmFuZ2VcIixcblx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHRjb2xvcjogXCJibGFja1wiLFxuXHRcdFx0XHRcdHRleHRMY3o6IFwiYmFzZS5idXR0b25zLmZhdm9yaXRlc1wiLFxuXHRcdFx0XHR9LFxuXHRcdFx0XHRzbG90czoge1xuXHRcdFx0XHRcdGljb246IHtcblx0XHRcdFx0XHRcdGF0dHJzOiB7XG5cdFx0XHRcdFx0XHRcdGljb246IFwic29sYXI6c3Rhci1ib2xkXCIsXG5cdFx0XHRcdFx0XHRcdGNvbG9yOiBcIiM0NzQ1NTRcIixcblx0XHRcdFx0XHRcdH0sXG5cdFx0XHRcdFx0fSxcblx0XHRcdFx0fSxcblx0XHRcdH0sXG5cdFx0XHR1cGxvYWQ6IHtcblx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHR0ZXh0TGN6OiBcImJhc2UuYnV0dG9ucy5sb2FkXCIsXG5cdFx0XHRcdH0sXG5cdFx0XHRcdHNsb3RzOiB7XG5cdFx0XHRcdFx0aWNvbjoge1xuXHRcdFx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHRcdFx0aWNvbjogXCJsZXRzLWljb25zOnVwbG9hZC1kdW90b25lXCIsXG5cdFx0XHRcdFx0XHRcdGNvbG9yOiBcInByaW1hcnlcIixcblx0XHRcdFx0XHRcdH0sXG5cdFx0XHRcdFx0fSxcblx0XHRcdFx0fSxcblx0XHRcdH0sXG5cdFx0fSxcblx0fSxcbn07XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBZSxxQkFBQTtBQUFBLEVBQ2QsYUFBYTtBQUFBLElBQ1osT0FBTztBQUFBLElBQ1AsT0FBTztBQUFBLE1BQ04sU0FBUztBQUFBLE1BQ1QsT0FBTztBQUFBLElBQ1A7QUFBQSxJQUNELFNBQVM7QUFBQSxNQUNSLE1BQU07QUFBQSxRQUNMLE9BQU87QUFBQSxVQUNOLFNBQVM7QUFBQSxRQUNUO0FBQUEsTUFDRDtBQUFBLE1BQ0QsQ0FBQyxXQUFXLEdBQUc7QUFBQSxRQUNkLE9BQU87QUFBQSxRQUNQLE9BQU87QUFBQSxVQUNOLFdBQVc7QUFBQSxVQUNYLFFBQVE7QUFBQSxVQUNSLGFBQWE7QUFBQSxRQUNiO0FBQUEsTUFDRDtBQUFBLE1BQ0QsUUFBUTtBQUFBLFFBQ1AsT0FBTztBQUFBLFFBQ1AsT0FBTztBQUFBLFVBQ04sT0FBTztBQUFBLFFBQ1A7QUFBQSxNQUNEO0FBQUEsTUFDRCxRQUFRO0FBQUEsUUFDUCxPQUFPO0FBQUEsUUFDUCxPQUFPLENBQUU7QUFBQSxNQUNUO0FBQUEsTUFDRCxNQUFNO0FBQUEsUUFDTCxPQUFPO0FBQUEsUUFDUCxPQUFPO0FBQUEsVUFDTixTQUFTO0FBQUEsVUFDVCxPQUFPO0FBQUEsUUFDUDtBQUFBLE1BQ0Q7QUFBQSxNQUNELE1BQU07QUFBQSxRQUNMLE9BQU87QUFBQSxRQUNQLGlCQUFpQjtBQUFBLFFBQ2pCLE9BQU87QUFBQSxVQUNOLFdBQVc7QUFBQSxVQUNYLFNBQVM7QUFBQSxVQUNULGFBQWE7QUFBQSxRQUNiO0FBQUEsUUFDRCxPQUFPO0FBQUEsVUFDTixNQUFNO0FBQUEsWUFDTCxPQUFPO0FBQUEsY0FDTixNQUFNO0FBQUEsY0FDTixNQUFNO0FBQUEsWUFDTjtBQUFBLFVBQ0Q7QUFBQSxRQUNEO0FBQUEsTUFDRDtBQUFBLE1BQ0QsV0FBVztBQUFBLFFBQ1YsT0FBTztBQUFBLFFBQ1AsaUJBQWlCO0FBQUEsUUFDakIsT0FBTztBQUFBLFVBQ04sU0FBUztBQUFBLFVBQ1QsT0FBTztBQUFBLFVBQ1AsTUFBTTtBQUFBLFFBQ047QUFBQSxRQUNELE9BQU87QUFBQSxVQUNOLE1BQU07QUFBQSxZQUNMLE9BQU87QUFBQSxjQUNOLE1BQU07QUFBQSxjQUNOLE1BQU07QUFBQSxZQUNOO0FBQUEsVUFDRDtBQUFBLFFBQ0Q7QUFBQSxNQUNEO0FBQUEsTUFDRCxXQUFXO0FBQUEsUUFDVixRQUFRO0FBQUEsUUFDUixPQUFPO0FBQUEsVUFDTixNQUFNO0FBQUEsUUFDTjtBQUFBLFFBQ0QsT0FBTztBQUFBLFVBQ04sTUFBTTtBQUFBLFlBQ0wsT0FBTztBQUFBLGNBQ04sTUFBTTtBQUFBLGNBQ04sTUFBTTtBQUFBLFlBQ047QUFBQSxVQUNEO0FBQUEsUUFDRDtBQUFBLE1BQ0Q7QUFBQSxNQUNELFlBQVk7QUFBQSxRQUNYLFFBQVE7QUFBQSxRQUNSLE9BQU87QUFBQSxVQUNOLE1BQU07QUFBQSxZQUNMLE9BQU87QUFBQSxjQUNOLE1BQU07QUFBQSxZQUNOO0FBQUEsVUFDRDtBQUFBLFFBQ0Q7QUFBQSxNQUNEO0FBQUEsTUFDRCxVQUFVO0FBQUEsUUFDVCxRQUFRO0FBQUEsUUFDUixPQUFPO0FBQUEsVUFDTixNQUFNO0FBQUEsWUFDTCxPQUFPO0FBQUEsY0FDTixNQUFNO0FBQUEsWUFDTjtBQUFBLFVBQ0Q7QUFBQSxRQUNEO0FBQUEsTUFDRDtBQUFBLE1BQ0QsY0FBYztBQUFBLFFBQ2IsUUFBUTtBQUFBLFFBQ1IsT0FBTztBQUFBLFVBQ04sTUFBTTtBQUFBLFlBQ0wsT0FBTztBQUFBLGNBQ04sTUFBTTtBQUFBLFlBQ047QUFBQSxVQUNEO0FBQUEsUUFDRDtBQUFBLE1BQ0Q7QUFBQSxNQUNELFFBQVE7QUFBQSxRQUNQLE9BQU87QUFBQSxVQUNOLFNBQVM7QUFBQSxRQUNUO0FBQUEsUUFDRCxPQUFPO0FBQUEsVUFDTixNQUFNO0FBQUEsWUFDTCxPQUFPO0FBQUEsY0FDTixNQUFNO0FBQUEsWUFDTjtBQUFBLFVBQ0Q7QUFBQSxRQUNEO0FBQUEsTUFDRDtBQUFBLE1BQ0QsTUFBTTtBQUFBLFFBQ0wsT0FBTztBQUFBLFFBQ1AsT0FBTztBQUFBLFVBQ04sU0FBUztBQUFBLFVBQ1QsT0FBTztBQUFBLFVBQ1AsU0FBUztBQUFBLFFBQ1Q7QUFBQSxRQUNELE9BQU87QUFBQSxVQUNOLE1BQU07QUFBQSxZQUNMLE9BQU87QUFBQSxjQUNOLE1BQU07QUFBQSxZQUNOO0FBQUEsVUFDRDtBQUFBLFFBQ0Q7QUFBQSxNQUNEO0FBQUEsTUFDRCxRQUFRO0FBQUEsUUFDUCxRQUFRO0FBQUEsUUFDUixPQUFPO0FBQUEsVUFDTixTQUFTO0FBQUEsUUFDVDtBQUFBLFFBQ0QsT0FBTztBQUFBLFVBQ04sTUFBTTtBQUFBLFlBQ0wsT0FBTztBQUFBLGNBQ04sTUFBTTtBQUFBLGNBQ04sT0FBTztBQUFBLFlBQ1A7QUFBQSxVQUNEO0FBQUEsUUFDRDtBQUFBLE1BQ0Q7QUFBQSxNQUNELE9BQU87QUFBQSxRQUNOLE9BQU87QUFBQSxVQUNOLFNBQVM7QUFBQSxVQUNULE9BQU87QUFBQSxVQUNQLFNBQVM7QUFBQSxRQUNUO0FBQUEsTUFDRDtBQUFBLE1BQ0QsZUFBZTtBQUFBLFFBQ2QsUUFBUTtBQUFBLFFBQ1IsT0FBTztBQUFBLFFBQ1AsT0FBTztBQUFBLFVBQ04sTUFBTTtBQUFBLFlBQ0wsT0FBTztBQUFBLGNBQ04sTUFBTTtBQUFBLGNBQ04sT0FBTztBQUFBLFlBQ1A7QUFBQSxVQUNEO0FBQUEsUUFDRDtBQUFBLFFBQ0QsT0FBTztBQUFBLFVBQ04sU0FBUztBQUFBLFFBQ1Q7QUFBQSxNQUNEO0FBQUEsTUFDRCxXQUFXO0FBQUEsUUFDVixRQUFRO0FBQUEsUUFDUixPQUFPO0FBQUEsUUFDUCxPQUFPO0FBQUEsVUFDTixNQUFNO0FBQUEsWUFDTCxPQUFPO0FBQUEsY0FDTixNQUFNO0FBQUEsY0FDTixPQUFPO0FBQUEsWUFDUDtBQUFBLFVBQ0Q7QUFBQSxRQUNEO0FBQUEsUUFDRCxPQUFPO0FBQUEsVUFDTixTQUFTO0FBQUEsUUFDVDtBQUFBLE1BQ0Q7QUFBQSxNQUNELGdCQUFnQjtBQUFBLFFBQ2YsUUFBUTtBQUFBLFFBQ1IsT0FBTztBQUFBLFFBQ1AsT0FBTztBQUFBLFVBQ04sTUFBTTtBQUFBLFlBQ0wsT0FBTztBQUFBLGNBQ04sTUFBTTtBQUFBLGNBQ04sT0FBTztBQUFBLFlBQ1A7QUFBQSxVQUNEO0FBQUEsUUFDRDtBQUFBLFFBQ0QsT0FBTztBQUFBLFVBQ04sT0FBTztBQUFBLFVBQ1AsU0FBUztBQUFBLFFBQ1Q7QUFBQSxNQUNEO0FBQUEsTUFDRCxlQUFlO0FBQUEsUUFDZCxPQUFPO0FBQUEsVUFDTixTQUFTO0FBQUEsUUFDVDtBQUFBLFFBQ0QsT0FBTztBQUFBLFVBQ04sTUFBTTtBQUFBLFlBQ0wsT0FBTztBQUFBLGNBQ04sTUFBTTtBQUFBLFlBQ047QUFBQSxVQUNEO0FBQUEsUUFDRDtBQUFBLE1BQ0Q7QUFBQSxNQUNELGdCQUFnQjtBQUFBLFFBQ2YsUUFBUTtBQUFBLFFBQ1IsT0FBTyxDQUFFO0FBQUEsUUFDVCxPQUFPO0FBQUEsVUFDTixNQUFNO0FBQUEsWUFDTCxPQUFPO0FBQUEsY0FDTixNQUFNO0FBQUEsWUFDTjtBQUFBLFVBQ0Q7QUFBQSxRQUNEO0FBQUEsTUFDRDtBQUFBLE1BQ0QsVUFBVTtBQUFBLFFBQ1QsT0FBTztBQUFBLFVBQ04sU0FBUztBQUFBLFFBQ1Q7QUFBQSxRQUNELE9BQU87QUFBQSxVQUNOLE1BQU07QUFBQSxZQUNMLE9BQU87QUFBQSxjQUNOLE1BQU07QUFBQSxjQUNOLE9BQU87QUFBQSxZQUNQO0FBQUEsVUFDRDtBQUFBLFFBQ0Q7QUFBQSxNQUNEO0FBQUEsTUFDRCxLQUFLO0FBQUEsUUFDSixPQUFPO0FBQUEsUUFDUCxPQUFPO0FBQUEsVUFDTixNQUFNO0FBQUEsWUFDTCxPQUFPO0FBQUEsY0FDTixNQUFNO0FBQUEsWUFDTjtBQUFBLFVBQ0Q7QUFBQSxRQUNEO0FBQUEsUUFDRCxPQUFPO0FBQUEsVUFDTixTQUFTO0FBQUEsVUFDVCxTQUFTO0FBQUEsUUFDVDtBQUFBLE1BQ0Q7QUFBQSxNQUNELFNBQVM7QUFBQSxRQUNSLE9BQU87QUFBQSxRQUNQLE9BQU87QUFBQSxVQUNOLFNBQVM7QUFBQSxVQUNULE9BQU87QUFBQSxVQUNQLFNBQVM7QUFBQSxRQUNUO0FBQUEsUUFDRCxPQUFPO0FBQUEsVUFDTixNQUFNO0FBQUEsWUFDTCxPQUFPO0FBQUEsY0FDTixPQUFPO0FBQUEsY0FDUCxNQUFNO0FBQUEsWUFDTjtBQUFBLFVBQ0Q7QUFBQSxRQUNEO0FBQUEsTUFDRDtBQUFBLE1BQ0QsY0FBYztBQUFBLFFBQ2IsUUFBUTtBQUFBLFFBQ1IsT0FBTztBQUFBLFVBQ04sU0FBUztBQUFBLFFBQ1Q7QUFBQSxRQUNELE9BQU87QUFBQSxVQUNOLE1BQU07QUFBQSxZQUNMLE9BQU87QUFBQSxjQUNOLE9BQU87QUFBQSxjQUNQLE1BQU07QUFBQSxZQUNOO0FBQUEsVUFDRDtBQUFBLFFBQ0Q7QUFBQSxNQUNEO0FBQUEsTUFDRCxhQUFhO0FBQUEsUUFDWixPQUFPO0FBQUEsVUFDTixTQUNDO0FBQUEsUUFDRDtBQUFBLFFBQ0QsT0FBTztBQUFBLFVBQ04sTUFBTTtBQUFBLFlBQ0wsT0FBTztBQUFBLGNBQ04sTUFBTTtBQUFBLFlBQ047QUFBQSxVQUNEO0FBQUEsUUFDRDtBQUFBLE1BQ0Q7QUFBQSxNQUNELE1BQU07QUFBQSxRQUNMLE9BQU87QUFBQSxVQUNOLFNBQVM7QUFBQSxRQUNUO0FBQUEsUUFDRCxPQUFPO0FBQUEsVUFDTixNQUFNO0FBQUEsWUFDTCxPQUFPO0FBQUEsY0FDTixNQUFNO0FBQUEsWUFDTjtBQUFBLFVBQ0Q7QUFBQSxRQUNEO0FBQUEsTUFDRDtBQUFBLE1BQ0QsWUFBWTtBQUFBLFFBQ1gsT0FBTztBQUFBLFVBQ04sU0FBUztBQUFBLFFBQ1Q7QUFBQSxRQUNELE9BQU87QUFBQSxVQUNOLE1BQU07QUFBQSxZQUNMLE9BQU87QUFBQSxjQUNOLE1BQU07QUFBQSxjQUNOLE9BQU87QUFBQSxZQUNQO0FBQUEsVUFDRDtBQUFBLFFBQ0Q7QUFBQSxNQUNEO0FBQUEsTUFDRCxNQUFNO0FBQUEsUUFDTCxPQUFPO0FBQUEsVUFDTixTQUFTO0FBQUEsUUFDVDtBQUFBLFFBQ0QsT0FBTztBQUFBLFVBQ04sTUFBTTtBQUFBLFlBQ0wsT0FBTztBQUFBLGNBQ04sTUFBTTtBQUFBLFlBQ047QUFBQSxVQUNEO0FBQUEsUUFDRDtBQUFBLE1BQ0Q7QUFBQSxNQUNELGFBQWE7QUFBQSxRQUNaLE9BQU87QUFBQSxVQUNOLFNBQVM7QUFBQSxRQUNUO0FBQUEsUUFDRCxPQUFPO0FBQUEsVUFDTixNQUFNO0FBQUEsWUFDTCxPQUFPO0FBQUEsY0FDTixNQUFNO0FBQUEsWUFDTjtBQUFBLFVBQ0Q7QUFBQSxRQUNEO0FBQUEsTUFDRDtBQUFBLE1BQ0QsUUFBUTtBQUFBLFFBQ1AsUUFBUTtBQUFBLFFBQ1IsT0FBTztBQUFBLFVBQ04sU0FBUztBQUFBLFFBQ1Q7QUFBQSxRQUNELE9BQU87QUFBQSxVQUNOLE1BQU07QUFBQSxZQUNMLE9BQU87QUFBQSxjQUNOLE1BQU07QUFBQSxZQUNOO0FBQUEsVUFDRDtBQUFBLFFBQ0Q7QUFBQSxNQUNEO0FBQUEsTUFDRCxhQUFhO0FBQUEsUUFDWixPQUFPO0FBQUEsVUFDTixTQUFTO0FBQUEsUUFDVDtBQUFBLFFBQ0QsT0FBTztBQUFBLFVBQ04sTUFBTTtBQUFBLFlBQ0wsT0FBTztBQUFBLGNBQ04sTUFBTTtBQUFBLFlBQ047QUFBQSxVQUNEO0FBQUEsUUFDRDtBQUFBLE1BQ0Q7QUFBQSxNQUNELGtCQUFrQjtBQUFBLFFBQ2pCLE9BQU87QUFBQSxRQUNQLE9BQU87QUFBQSxVQUNOLE9BQU87QUFBQSxVQUNQLFNBQVM7QUFBQSxRQUNUO0FBQUEsUUFDRCxPQUFPO0FBQUEsVUFDTixNQUFNO0FBQUEsWUFDTCxPQUFPO0FBQUEsY0FDTixNQUFNO0FBQUEsY0FDTixPQUFPO0FBQUEsWUFDUDtBQUFBLFVBQ0Q7QUFBQSxRQUNEO0FBQUEsTUFDRDtBQUFBLE1BQ0QsUUFBUTtBQUFBLFFBQ1AsT0FBTztBQUFBLFVBQ04sU0FBUztBQUFBLFFBQ1Q7QUFBQSxRQUNELE9BQU87QUFBQSxVQUNOLE1BQU07QUFBQSxZQUNMLE9BQU87QUFBQSxjQUNOLE1BQU07QUFBQSxjQUNOLE9BQU87QUFBQSxZQUNQO0FBQUEsVUFDRDtBQUFBLFFBQ0Q7QUFBQSxNQUNEO0FBQUEsSUFDRDtBQUFBLEVBQ0Q7QUFDRjsifQ==
